<!--  CONTACT KEY VALUE LIST  -->

<ui-key-value-list [items]="dealerContactItems" [size]="'large'" [adjacentAt]="'sm3'" [style]="'striped'" [keyCols]="15"></ui-key-value-list>

<!-- END CONTACT KEY VALUE LIST  -->
